<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>目录创建</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/training')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <tz-form
        width="110px"
        :formConfig="formConfig"
        :formBtns="formBtns"
        @submit="submitFn"
      ></tz-form>
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addCatalog } from '@/api/training'

export default {
  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '标题',
          field: 'title',
          type: 'text',
          rules: [{ required: true, message: '标题必填', trigger: 'blur' }]
        },
        {
          label: '介绍',
          field: 'introduce',
          type: 'text',
          rules: [{ required: true, message: '介绍必填', trigger: 'blur' }]
        },
        {
          label: '讲解人',
          field: 'explainer',
          type: 'text'
          // rules: [{ required: true, message: '讲解人必填', trigger: 'blur' }]
        },
        {
          label: '开始时间',
          field: 'startDt',
          type: 'datepicker',
          placeholder: '请选择开始日期'
          // rules: [{ required: true, message: '开始时间必选', trigger: 'blur' }]
        },
        {
          label: '结束时间',
          field: 'endDt',
          type: 'datepicker',
          placeholder: '请选择结束日期'
          // rules: [{ required: true, message: '结束时间必选', trigger: 'blur' }]
        },

        {
          label: '备注',
          field: 'remark',
          type: 'text'
          // rules: [{ required: true, message: '备注必填', trigger: 'blur' }]
        },
        {
          label: '排序',
          field: 'sort',
          type: 'text'
          // rules: [{ required: true, message: '排序必填', trigger: 'blur' }]
        }
      ],
      formBtns: [
        {
          content: '创建',
          width: '185px',
          type: 'primary'
        }
        // {
        //   content: '重置',
        //   width: '185px',
        //   type: ''
        // }
      ]
    }
  },
  methods: {
    submitFn(formData) {
      console.log(formData, '目录创建')
      if (this.submited) return
      this.$loading({
        text: '目录添加中'
      })
      let infos = JSON.parse(JSON.stringify(formData))
      let addparams = {
        title: infos.title,
        introduce: infos.introduce,
        sort: infos.sort,
        explainer: infos.explainer,
        startDt: infos.startDt,
        endDt: infos.endDt,
        remark: infos.remark,
        status: '1'
      }
      console.log(addparams)
      addCatalog(addparams).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.submited = true
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.$router.go(-1)
        } else {
          this.$message({
            message: res.data,
            type: 'error'
          })
        }
      })
      this.$loading().close()
    }
  }
}
</script>

<style></style>
